import React from 'react';
import { Check } from '@finect/tabular-icons/check';
import { CheckboxBlock } from './partials';
export var Checkbox = function Checkbox(_ref) {
  var id = _ref.id,
    name = _ref.name,
    _ref$simple = _ref.simple,
    simple = _ref$simple === void 0 ? false : _ref$simple,
    value = _ref.value,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    handleChange = _ref.handleChange,
    onChange = _ref.onChange,
    children = _ref.children,
    checked = _ref.checked,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var handleChangeFn = handleChange ? handleChange : onChange;
  return React.createElement(CheckboxBlock, {
    withLabel: Boolean(children),
    disabled: disabled,
    simple: simple
  }, React.createElement("input", {
    type: "checkbox",
    id: id,
    name: name,
    value: value,
    onChange: handleChangeFn,
    required: required,
    checked: checked,
    disabled: disabled
  }), React.createElement("label", {
    htmlFor: id
  }, React.createElement(Check, {
    size: "15",
    strokeWidth: "3"
  }), children ? children : null));
};